import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class CompositionService {
  url=ConfigService.toApiUrl("compositions/");

  constructor(private http:HttpClient) { }

    getAll(){
    return this.http.get<any[]>(`${this.url}`,ConfigService.addAction('list'));
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-by-state")}/${state}`,ConfigService.addAction('list'));
  }
  
  getNextCompostionForStudent(studentId?:any){
    if (studentId==undefined) {
      return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-student-next-composition")}`,ConfigService.addAction('list'));

    }else{
      return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-student-next-composition")}?studentId=${studentId}`,ConfigService.addAction('list'));

    }
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.addAction('add'));
  }

  update(id:any,ressource:any){
    ressource['_method']='patch';
    //ressource.append('_method','patch');

    return this.http.post<any>(`${this.url}${id}`, ressource,  ConfigService.addAction('edit'));
  }

  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.addAction('delete'));
  }

  confirm(id:any,state:any){
    return this.http.get<any>(`${ConfigService.toApiUrl("compositions-confirmation/")}${id}/state/${state}`,
     ConfigService.addAction('status'));
  }


  setAppreciation(resource:any){
    return this.http.post<any>(`${ConfigService.toApiUrl("compositions-averages-appreciation/")}`,resource,
     ConfigService.addAction('add'));
  }

  setGeneraleAppreciation(resource:any){
    return this.http.post<any>(`${ConfigService.toApiUrl("compositions-bulletins-appreciation/")}`,resource,
     ConfigService.addAction('add'));
  }


  getOneBulletin(classroomId:any,periodId:any,sacId:any){
    return this.http.get<any>(`${ConfigService.toApiUrl("compositions-get-one-bulletin/")}${classroomId}/${periodId}/${sacId}`,
     ConfigService.addAction('add'));
  }

  forAverage(id:any,state:any){
    return this.http.get<any>(`${ConfigService.toApiUrl("compositions-for-average/")}${id}/state/${state}`,
     ConfigService.addAction('list'));
  }

  validate(id:any,state:any){
    return this.http.get<any>(`${ConfigService.toApiUrl("compositions-validation/")}${id}/state/${state}`,
     ConfigService.addAction('status'));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.addAction('show'));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-set-state")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }

  getByClassroomPeriods(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-by-classroom-periods")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }

  getByClassroomPeriodsState(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-by-classroom-periods-state")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }
  generateBulletin(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-generate-bulletin")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }
  
  getBulletin(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-get-bulletin")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }
  getBulletinDetails(classroomId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-get-bulletin-details")}/${classroomId}/${periodId}`,ConfigService.addAction('list'));
  }
  getNoteBook(paccId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-get-note-book")}/${paccId}/${periodId}`,ConfigService.addAction('list'));
  }

  getByCoursePeriod(paccId:any,periodId:any,forNote:any=0){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-by-course-period")}/${paccId}/${periodId}/${forNote}`,ConfigService.addAction('list'));
  }
  getByCoursePeriodConfirmed(paccId:any,periodId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("compositions-by-course-period-confirmed")}/${paccId}/${periodId}`,ConfigService.addAction('list'));
  }
}
